export const MAIN_CONTENT_ID = 'main';

export const NOOP = () => {};

export const NON_BREAKING_HYPHEN = '‑';

export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze<any>([]);
